<template>
  <div class="relative" :class="colSpan">
    <label class="text-xs" :for="field.handle">
      {{ label || field.label }}
    </label>
    <Listbox v-model="selectedCountry" as="div" class="relative w-full">
      <ListboxButton
        class="focus-default relative h-[3.75rem] w-full rounded-md bg-second-blue-200/50 px-5 pr-[3.25rem] ui-open:rounded-b-none"
      >
        <div
          class="flex items-center space-x-3 text-base"
          :class="{
            'text-main-blue-hover opacity-50':
              selectedCountry.title === 'Select a country',
          }"
        >
          <img class="w-6" :src="selectedCountry.flag?.permalink" />
          <p>{{ selectedCountry.title }}</p>
          <ArrowSimpleIcon
            class="absolute right-5 w-3 text-main-blue transition-transform ui-open:rotate-180"
          />
        </div>
      </ListboxButton>

      <transition name="fade">
        <ListboxOptions
          class="focus-default absolute z-20 max-h-56 w-full overflow-auto rounded-b-md rounded-t-none border-x border-b bg-white ring-offset-0"
        >
          <ListboxOption
            v-for="country in countriesSorted"
            :key="country.iso2"
            :value="country"
            class="flex cursor-pointer items-center space-x-3 px-5 py-2 hover:bg-second-blue-200/50 ui-selected:bg-main-blue/50 ui-selected:text-white ui-active:bg-second-blue-200/50 ui-selected:ui-active:bg-main-blue-hover/50"
          >
            <img class="w-6" :src="country.flag?.permalink" />
            <p>{{ country.title }}</p>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </Listbox>

    <transition name="fade">
      <p v-if="error" class="mt-1 text-xs text-red-500">{{ error }}</p>
    </transition>
  </div>
</template>

<script setup>
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'

const props = defineProps({
  countries: { type: Array, required: true },
  field: { type: Object, required: true },
  value: { type: null, default: '' },
  error: { type: String, default: null },
  disabled: { type: Boolean, default: false },
  label: { type: String, default: '' },
})

const emit = defineEmits(['input'])

const selectedCountry = ref({
  title: 'Select a country',
  flag: {
    permalink: '/images/globe-icon.svg',
  },
})

const countriesSorted = computed(() => {
  if (!props.countries) {
    return []
  }

  // Find index of the country with ISO2 code 'CH'
  let index = props.countries.findIndex((country) => country.iso2 === 'CH')

  if (index !== -1) {
    let countriesSorted = JSON.parse(JSON.stringify(props.countries))

    let [country] = countriesSorted.splice(index, 1)
    countriesSorted.unshift(country)

    return countriesSorted
  }

  return props.countries
})

watch(selectedCountry, (currentValue) => {
  emit('input', currentValue)
})

const colSpan = computed(() => {
  const width = props.field.width || 100

  switch (width) {
    case 25:
      return 'sm:col-span-3 col-span-2'
    case 33:
      return 'sm:col-span-4 col-span-4'
    case 50:
      return 'sm:col-span-6 col-span-4'
    case 66:
      return 'sm:col-span-8 col-span-4'
    default:
      return 'sm:col-span-12 col-span-4'
  }
})
</script>
